import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { CourtForAddBookingTimeSlotsModel } from '@bayclubs/court-booking-employee-api';

export const CUSTOM_TIME_SLOT_SELECT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimeSlotsSelectComponent),
    multi: true
};

@Component({
    selector: 'app-time-slots-select',
    templateUrl: './time-slots-select.component.html',
    styleUrls: ['./time-slots-select.component.scss'],
    providers: [CUSTOM_TIME_SLOT_SELECT_VALUE_ACCESSOR],
    standalone: false
})
export class TimeSlotsSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
    @Input() timeSlots: CourtForAddBookingTimeSlotsModel[] = [];

    form: UntypedFormGroup;

    subscription: Subscription = new Subscription();

    constructor(private formBuilder: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            timeSlot: [null, []]
        });

        this.subscription.add(
            this.form.controls.timeSlot.valueChanges.subscribe(value => {
                this.onChange(value);
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onChange = (selected: string) => { };
    onTouched = () => { };

    writeValue(obj: string): void {
        this.form.controls.timeSlot.setValue(obj);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void { }
}

export interface TimeSlotFormModel {
    timeSlot: string;
}
